"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const kor_1 = require("./kor");
function generateTimestamp() {
    return (new Date()).valueOf() * 1000000 + Math.random() * 1000000;
}
exports.generateTimestamp = generateTimestamp;
function calculateTransformFromVectors2(pivot, v1, v2) {
    if (v1.length < 2 || v2.length < 2) {
        console.log('ERROR: calculateTransformFromVectors incorrect vectors', v1, v2);
        return null;
    }
    const vn1 = v1[1].subtract(v1[0]);
    const vn2 = v2[1].subtract(v2[0]);
    // Calculate transform
    const rotate = vn1.angleTo(vn2);
    const scale = Math.sqrt(vn2.magnitude2() / vn1.magnitude2());
    // Calculate displacement
    const vp = pivot.subtract(v1[0]); // vector to pivot
    const vd = vp.rotate(rotate).scale(scale); // transformed vector
    const p2 = v2[0].add(vd); // new pivot
    const move = p2.subtract(pivot);
    return { move, rotate, scale };
}
exports.calculateTransformFromVectors2 = calculateTransformFromVectors2;
function convertPointFromBoundingBox(fromP, fromRect, toRotation, toSize) {
    const diag = toSize;
    const diagR = Math.atan2(toSize.height, toSize.width);
    const toR = kor_1.normalizeRotation(toRotation);
    const cross = diag.rotate(toR);
    let scale;
    if ((toR % Math.PI) < Math.PI / 2) {
        const crossL = Math.abs(Math.sin(toR + diagR)) * cross.magnitude();
        scale = fromRect.size.height / crossL;
    }
    else {
        const crossL = Math.abs(Math.cos(toR + diagR)) * cross.magnitude();
        scale = fromRect.size.width / crossL;
    }
    // ---- Process the point
    const pCenter = fromP.subtract(fromRect.center);
    const pRotated = pCenter.rotate(-toR).scale(1 / scale); // Unrotate and unscale
    return toSize.center().add(pRotated);
}
exports.convertPointFromBoundingBox = convertPointFromBoundingBox;
// ==========================================================================
function btap(...args) {
    console.log(...args);
    return true;
}
exports.btap = btap;
function bflip(f) {
    return (t) => !f(t);
}
exports.bflip = bflip;
function safeKey(obj, key) {
    return ((typeof obj === 'object') || undefined)
        && (key in obj || undefined)
        && obj[key];
}
exports.safeKey = safeKey;
